import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c6e363f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fw-bold text-center" }
const _hoisted_2 = { class: "__info" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-map fas me-2" }, null, -1))
const _hoisted_6 = { class: "ms-auto ps-2 text-end" }
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = { class: "fw-bold" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-calendar fas me-2" }, null, -1))
const _hoisted_10 = { class: "ms-auto ps-2 text-end" }
const _hoisted_11 = { class: "__info-more" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "d-flex" }
const _hoisted_14 = { class: "fw-bold" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-info fas me-2" }, null, -1))
const _hoisted_16 = { class: "ms-auto ps-2 text-end" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 0,
  class: "d-flex justify-content-center p-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_observer_component = _resolveComponent("observer-component")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
          return (_openBlock(), _createBlock(_component_el_col, {
            key: item.id,
            lg: 6,
            md: 8,
            sm: 12,
            xs: 24,
            class: "__item"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, {
                id: item.id
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, _toDisplayString(item.name) + " - " + _toDisplayString(item.code), 1),
                  _createElementVNode("div", _hoisted_2, [
                    (item.province)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createElementVNode("div", _hoisted_4, [
                            _hoisted_5,
                            _createTextVNode(_toDisplayString(_ctx.$t("label.province")), 1)
                          ]),
                          _createElementVNode("div", _hoisted_6, _toDisplayString(item.province), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_divider, { class: "__sep" }),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createTextVNode(_toDisplayString(_ctx.$t("label.date")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.dateFormatDate(item.lastUpdate)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_el_collapse, { accordion: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_collapse_item, {
                            name: "1",
                            onClick: ($event: any) => (_ctx.getHistory(item))
                          }, {
                            title: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("btn.showMore")), 1)
                            ]),
                            default: _withCtx(() => [
                              (item.aemetHistory)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getMagnitude(item.aemetHistory), (info) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: info.magnitude
                                      }, [
                                        _createVNode(_component_el_divider, { class: "__sep" }),
                                        _createElementVNode("div", _hoisted_13, [
                                          _createElementVNode("div", _hoisted_14, [
                                            _hoisted_15,
                                            _createTextVNode(_toDisplayString(info.magnitude), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_16, _toDisplayString(info.value), 1)
                                        ])
                                      ]))
                                    }), 128))
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.$t("warning.notData")), 1))
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["id"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    (_ctx.hasMore)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createVNode(_component_el_button, {
            primary: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showMore()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("btn.showMore")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_observer_component, { onIntersect: _ctx.showMore }, null, 8, ["onIntersect"])
        ]))
      : _createCommentVNode("", true)
  ]))
}